import { createHmac } from "crypto";

export const getPylonHashedEmail = (email: string) => {
  const secret = process.env.PYLON_IDENTITY_SECRET!;
  const secretBytes = Buffer.from(secret, "hex");
  return createHmac("sha256", secretBytes).update(email).digest("hex");
};
